import type { CbiFrontendServiceContext } from "../../frontend/context/CbiFrontendServiceContext";
import type { AgreementCategoryDTOBase } from "./AgreementCategoryDTOBase";
import type { AgreementRef } from "./AgreementRef";
import type { AgreementStaff } from "./AgreementStaff";
import type { CategoryRef } from "./CategoryRef";
import type { CategoryStaff } from "./CategoryStaff";

export class AgreementCategoryStaff implements AgreementCategoryDTOBase {
  constructor(public readonly assignId: number, public readonly agreementId: AgreementStaff | null, public readonly categoryId: CategoryStaff | null, public readonly agreementIdTargetIds: AgreementRef | null, public readonly categoryIdTargetIds: CategoryRef) {
    this.cbiServiceContext = null;
    this.agreementIdLoaded = this.agreementId != null;
    this.agreementIdCached = this.agreementId;
    this.categoryIdLoaded = this.categoryId != null;
    this.categoryIdCached = this.categoryId;
  }
  cbiServiceContext: CbiFrontendServiceContext | null;
  private agreementIdLoaded: boolean;
  private agreementIdCached: AgreementStaff | null;
  private categoryIdLoaded: boolean;
  private categoryIdCached: CategoryStaff | null;
  async agreementIdLazy(): Promise<AgreementStaff | null> {
    if (!this.agreementIdLoaded) {
      this.agreementIdCached = await (this.agreementIdTargetIds != null ? this.cbiServiceContext!.catalogService().getAgreementStaff(this.agreementIdTargetIds.assignId) : Promise.resolve(null));
      this.agreementIdLoaded = true;
    }
    return this.agreementIdCached;
  }
  async categoryIdLazy(): Promise<CategoryStaff> {
    if (!this.categoryIdLoaded) {
      this.categoryIdCached = await this.cbiServiceContext!.catalogService().getCategoryStaff(this.categoryIdTargetIds.assignId);
      this.categoryIdLoaded = true;
    }
    return this.categoryIdCached!;
  }
}
